export default __webpack_public_path__ + "static/media/icon_back_arrow.71e095c3.svg";